// Mirrors server/src/models/availability/StaffAvailability.js - 'Available'
// is a positive "I can work this window" declaration; the rest are periods
// the employee cannot work.
export const AVAILABILITY_TYPES = [
  'Available',
  'Unavailable',
  'Annual Leave',
  'Sickness',
  'Other',
]

// The types a staff member picks from on the "Unavailable" flow
export const UNAVAILABLE_TYPES = AVAILABILITY_TYPES.filter(
  (type) => type !== 'Available',
)

export const AVAILABILITY_TYPE_LABELS = {
  Available: 'Available to work',
  Unavailable: 'Unavailable',
  'Annual Leave': 'Annual Leave',
  Sickness: 'Sickness',
  Other: 'Other',
}

export const AVAILABILITY_STATUS_OPTIONS = [
  'All',
  'Active',
  'Pending',
  'Approved',
  'Rejected',
  'Cancelled',
]

export const AVAILABILITY_STATUS_COLOURS = {
  Pending: 'warning',
  Approved: 'success',
  Rejected: 'error',
  Cancelled: 'default',
}

export const isAvailableType = (type) => type === 'Available'

// Records that never need a manager's decision (mirrors isSelfApprovedType)
export const isSelfApprovedType = (type) =>
  type === 'Available' || type === 'Sickness'

export const isAvailableRecord = (record) =>
  record?.type === 'Available' && record?.status === 'Approved'

export const describeSubmissionOutcome = (type) => {
  if (isAvailableType(type)) {
    return 'Recorded straight away and shown to planners on the Global Roster - no approval needed.'
  }
  if (type === 'Sickness') return 'Recorded straight away.'
  return 'Sent to your manager for approval. The period is reserved while it waits.'
}
